import React, { useEffect, useState } from "react";
import { Button, TextField } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import CloseIcon from "@mui/icons-material/Close";
import DatePickerWithTimeComponent from "../DatePickerWithTimeComponent";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { useAuth } from "../../contexts/AuthContext";
import { showCustomToast } from "../Misc/CustomToast";

import Chip from "@mui/material/Chip";

function AddQuickNote(props) {

  const { currentUser } = useAuth();

  // useEffect(() => {
  //   recordMetrics("Notes", "quickNotes", currentUser.email, "write", "bodhi");
  // }, []);

  //Tous les states des données récupérées par client

  const [quickNoteText, setQuickNoteText] = useState("");
  const [effectiveDateTime, setEffectiveDateTime] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const draftKey = `draft:quickNote:${currentUser?.uid || "anon"}:${
    props.clientId || "unknown"
  }`;
  const draftDelay = 800;
  const [isSavingDraft, setIsSavingDraft] = useState(false);

  // const handleClose2 = () => setOpen2(false);

  // const handleQuickNoteChange = (event) => {
  //   setQuickNoteText(event);
  // };

  const handleDateTimeChange = (event) => {
    setEffectiveDateTime(event);
  };

  const handleAddQuickNote = async (note, clientID, effectiveDateTime) => {
    const noteData = {
      noteType: "quickNote",
      noteContent: note,
      clientId: clientID,
      createdAt: serverTimestamp(),
      effectiveDateTime: effectiveDateTime,
      doneBy: currentUser.displayName,
      clientFirstName: props.firstName,
      clientLastName: props.lastName,
      clientProfilePicture: props.profilePicture || "",
    };

    if (quickNoteText && effectiveDateTime) {
      setIsLoading(true);
      try {
        await addDoc(collection(db, "notes"), noteData);
        showCustomToast(`Quick note successfully added!`, "success");

        setIsLoading(false);
        try {
          localStorage.removeItem(draftKey);
        } catch {}
        props.closemodal();
      } catch (error) {
        console.log("error adding note :", error);
        showCustomToast(`Problem when adding note`, "error");
      }
    } else {
      showCustomToast(
        `Some mandatory fields are empty. Please check.`,
        "error"
      );
    }
  };

  const handleSubmit = () => {
    handleAddQuickNote(quickNoteText, props.clientId, effectiveDateTime);
  };

  const handleChange = (event) => {
    setQuickNoteText(event.target.value);
  };

  // Restore draft on mount
  useEffect(() => {
    try {
      const raw = localStorage.getItem(draftKey);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed?.text) setQuickNoteText(parsed.text);
        if (parsed?.date) {
          const d = new Date(parsed.date);
          if (!isNaN(d)) setEffectiveDateTime(d);
        }
      }
    } catch (e) {
      console.warn("QuickNote draft load error:", e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Autosave draft with debounce
  useEffect(() => {
    const t = setTimeout(() => {
      try {
        localStorage.setItem(
          draftKey,
          JSON.stringify({
            text: quickNoteText,
            date: effectiveDateTime?.toISOString?.() || null,
          })
        );
        setIsSavingDraft(false);
      } catch (e) {
        console.warn("QuickNote draft save error:", e);
      }
    }, draftDelay);
    setIsSavingDraft(true);
    return () => clearTimeout(t);
  }, [quickNoteText, effectiveDateTime, draftKey]);

  return (
    <>
      <div
        style={{ width: "auto", height: "100%" }}
        // className="inputAndLabelModalContainerTitle2"
      >
        {/* <div className="inputAndLabelModalContainerTitle2"> */}
        <div className="line1-modal-percent">
          <div className="modal-title">Add Quick Note</div>
          <CloseIcon
            style={{
              marginRight: "16px",
              color: "rgb(214, 213, 213)",
              cursor: "pointer",
            }}
            onClick={props.closemodal}
          />
        </div>

        <div
          style={{
            width: "100%",
            marginTop: "10px",
            height: "75%",
            overflowY: "scroll",
            overflowX: "hidden",
          }}
        >
          <div className="line2-column-modal-v2">
            <div className="label-textfield2">Note content</div>
            <TextField
              name="quickNote"
              value={quickNoteText}
              onChange={handleChange}
              style={{
                width: "95%",
                borderRadius: "5px",
                backgroundColor: "#f2eeef",
              }}
              placeholder="Type quick session note here"
              multiline
              rows={14}
            />
            <div
              className="line3-modal-nopad"
              style={{
                // marginLeft: "20px",

                paddingTop: "10px",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <DatePickerWithTimeComponent
                title="Effective date and time"
                value={effectiveDateTime}
                onChange={handleDateTimeChange}
                leftMargin="none"
              />
            </div>
          </div>
        </div>
        <div
          className="line4-modal-percent"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            gap: 10,
          }}
        >
          <Chip
            label={
              isSavingDraft
                ? "Saving draft..."
                : quickNoteText
                ? "Draft saved"
                : "No draft"
            }
            size="small"
            sx={{
              backgroundColor: isSavingDraft
                ? "#f9a825"
                : quickNoteText
                ? "#2e7d32"
                : "#607d8b",
              color: "#fff",
              fontWeight: 700,
            }}
          />
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              try {
                localStorage.removeItem(draftKey);
              } catch {}
              setQuickNoteText("");
              setEffectiveDateTime(new Date());
            }}
          >
            Clear draft
          </Button>
          <Button
            variant="contained"
            style={{ backgroundColor: "white", color: "black" }}
            onClick={props.closemodal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={
              isLoading
                ? {
                    backgroundColor: "red",
                    color: "white",
                    marginLeft: "15px",
                  }
                : {
                    backgroundColor: "#1565C0",
                    color: "white",
                    marginLeft: "15px",
                  }
            }
            disabled={isLoading}
            onClick={handleSubmit}
          >
            {isLoading ? "ADDING NOTES..." : "ADD NOTES"}
          </Button>
        </div>
      </div>
    </>
  );
}

export default AddQuickNote;
